export default __webpack_public_path__ + "static/media/down_arrow.3c5344e2.svg";